import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AlertService } from '../../../_shared/services/alert.service';
import { UtilService } from '../../../_shared/services/util.service';

import { OccupancyType } from '../../shared/occupancy-type.model';
import { OccupancyTypeService } from '../../shared/occupancy-type.service';

@Component({
  selector: 'app-occupancy-type-translation-modal',
  templateUrl: './occupancy-type-translation-modal.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class OccupancyTypeTranslationModalComponent {
  constructor(
    private alertService: AlertService,
    private utilService: UtilService,
    private occupancyTypeService: OccupancyTypeService,
    private formBuilder: FormBuilder,
    private ref: MatDialogRef<OccupancyTypeTranslationModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getOccupancyType();
  }

  occupancyType: OccupancyType = null;
  occupancyTypeCopy = null;

  modalTitle = this.data.title;
  occupancyTypeId = this.data.obj.id;
  language = this.data.params.language;

  form: FormGroup;

  serverErrors = [];
  sendingForm = false;

  // Referenced from app-item-detail-form-actions
  onSavedOccupancyTypeTranslation() {
    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const formData = this.form.value;

    const fields = ['name'];

    if (!fields.some((field) => formData[field] !== this.occupancyTypeCopy[field])) {
      this.close();
      return;
    }

    this.sendingForm = true;

    this.occupancyTypeService
      .saveOccupancyType(this.occupancyType.id, formData, this.language.lang)
      .subscribe({
        next: (response) => {
          this.alertService.open('TRANSLATION_SAVED');

          this.sendingForm = false;

          this.ref.close(response);
        },
        error: (response) => {
          this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

          this.sendingForm = false;
        },
      });
  }

  onCanceled() {
    this.close();
  }

  close() {
    this.ref.close();
  }

  private getOccupancyType() {
    let params = {
      get: 'translate',
      lang: this.language.lang,
    };

    this.occupancyTypeService
      .getOccupancyType(this.occupancyTypeId, params)
      .subscribe((occupancyType) => {
        this.occupancyType = occupancyType;
        this.occupancyTypeCopy = { ...this.occupancyType };

        this.setOccupancyTypeTranslationForm();

        this.form.patchValue(this.occupancyType);
      });
  }

  private setOccupancyTypeTranslationForm() {
    this.form = this.formBuilder.group({
      name: [
        '',
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), used it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
    });
  }
}

/*

const formData = this.utilService.deleteNullFields(fields, this.form.value);

this.form = this.formBuilder.group({
      name: [
        this.occupancyType.name,
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), used it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
    });

*/
